module.exports = __webpack_public_path__ + "img/C_RGB APP.1fefb769.png";